import { createEvent } from "@cobuildlab/react-simple-state";
import { User } from "@devsplan/wealthclub-shared";

export const OnFetchMe = createEvent<User>();
export const OnFetchMeError = createEvent();
